import React, { forwardRef } from 'react'
import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';

function stringToColor(string) {
  let hash = 0;
  let i;

  /* eslint-disable no-bitwise */
  for (i = 0; i < string?.length; i += 1) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash);
  }

  let color = '#';

  for (i = 0; i < 3; i += 1) {
    const value = (hash >> (i * 8)) & 0xff;
    color += `00${value.toString(16)}`.slice(-2);
  }
  /* eslint-enable no-bitwise */

  return color;
}

function stringAvatar(name) {
  if (!name) return {};

  const firstLetter = name.charAt(0).toUpperCase();

  return {
    sx: {
      bgcolor: stringToColor(name),
      color: 'white',
      width: 32,
      height: 32,
      fontSize: '1rem',
    },
    children: firstLetter,
  };
}

const AvatarComponent = forwardRef((props, ref) => {
  const { string, ...rest } = props;
  return (
    <Box position="relative" display="inline-flex"> {/* Use Box to position Avatar and Icon */}
      <Avatar {...stringAvatar(string)} variant="rounded" ref={ref} {...rest} />    
    </Box>
  );
});

export default AvatarComponent;